import React, { useState } from "react";
import { OpelModal, PrestatricesList } from "../../organisms";
import { PrestatriceModal } from "../../mollecules";

function PrestatriceTemplate() {
  const [toggleModal, setToggleModal] = useState({
    active: false,
    category: null,
  });

  const openModal = () => {
    setToggleModal((prevState) => ({
      ...prevState,
      active: true,
    }));
  };
  const closeModal = () => {
    setToggleModal((prevState) => ({
      ...prevState,
      active: false,
      category: null,
    }));
  };
  const editModal = (id) => {
    setToggleModal((prevState) => ({
      ...prevState,
      active: true,
      category: id,
    }));
  };
  return (
    <div>
      {toggleModal.active && (
        <PrestatriceModal closeModal={closeModal} toggleModal={toggleModal} />
      )}
      <OpelModal title="Ajouter une prestatrice" openModal={openModal} />
      <PrestatricesList editModal={editModal} />
    </div>
  );
}

export default PrestatriceTemplate;
